import React, { useState, useEffect } from 'react'
import {
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExitIcon from '@material-ui/icons/ExitToApp'
import SaveIcon from '@material-ui/icons/Save'
import ReactTooltip from 'react-tooltip'
import { useAsistencia } from '../../../context/AsistenciaContext'
import Swal from 'sweetalert2'
import { useHistory } from 'react-router-dom'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Stack } from '@mui/material'
import NumberFormat from 'react-number-format'
import Typography from '@mui/material/Typography'
import { useFormTechnicalAssistance } from '../../../context/TechnicalAssistanceContext'
import { useAuthentication } from '../../../context/authenticationContext'
import { getCurrencyByCountry } from '../../../services/Elegibilidad/get'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import swal from 'sweetalert'
import {
  UploadReportCapacityBuilding,
  UploadReportCapacityBuildingGroupMipyme,
  UploadReportCapacityBuildingIFI,
  UploadReportTechnicalAssistancePreinvestment,
  UploadReportTechnicalAssistancePreinvestmentGroupMipyme,
  insertTechnicalAssistanceAnswers,
} from '../../../services/AsistenciaTecnica/create'
import { Table25 } from './Tables/TableSec2/Table25'
import Table26 from './Tables/TableSec2/Table26'
import { Table272 } from './Tables/TableSec2/Table272'
import { Table271 } from './Tables/TableSec2/Table271'
import Moment from 'moment'
import ROUTES from '../../../routers/routes'
import { LoadingButton } from '@mui/lab'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import { validateEditForm } from '../../../services/Forms/create'

export const AsistenciaSeccion2 = (props) => {
  const { assistanceForm, setAssistanceForm } = useFormTechnicalAssistance()
  const [currencyType, setCurrencyType] = useState([])
  const { userCountry, userIDB2C } = useAuthentication()
  const [saving, setSaving] = useState(false)
  const [errorNecesidades, setErrorNecesidades] = useState(false)
  const [errorLimitaciones, setErrorLimitaciones] = useState(false)
  const [errorProblemas, setErrorProblemas] = useState(false)
  const [errorObstaculos, setErrorObstaculos] = useState(false)
  const [errorObjetivo, setErrorObjetivo] = useState(false)
  const [errorEspecificoI, setErrorEspecificoI] = useState(false)
  const [errorEspecificoII, setErrorEspecificoII] = useState(false)
  const [errorEspecificoIII, setErrorEspecificoIII] = useState(false)
  const [errorActividades, setErrorActividades] = useState(false)
  const [errorAcciones, setErrorAcciones] = useState(false)

  const { goToStep, edit } = props
  const history = useHistory()
  const [, dispatch] = useAsistencia()

  const previous = () => {
    dispatch({ type: 'SET_STATE', payload: 1 })
    goToStep(1)
  }

  const next = () => {
    dispatch({ type: 'SET_STATE', payload: 3 })
    goToStep(3)
  }

  const cancelForm = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se perderán los datos no guardados',
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      confirmButtonColor: '#3085d6',
      denyButtonText: `No guardar`,
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await validateEditForm(
          userIDB2C,
          2,
          assistanceForm.IdTechnicalAssistanceAnswer,
        )

        if (response.Success) {
          const exit = true
          saveForm(formik.values, true, exit)
        }
      } else if (result.isDenied) {
        const response = await validateEditForm(
          userIDB2C,
          2,
          assistanceForm.IdTechnicalAssistanceAnswer,
        )
        if (response.Success) {
          if (edit) {
            history.push(ROUTES.IFIBORRADOR.pathname)
            dispatch({ type: 'SET_STATE', payload: 1 })
          } else {
            history.push('/')
            dispatch({ type: 'SET_STATE', payload: 1 })
          }
        }
      }
    })
  }

  const GeneralDataSchema = Yup.object().shape({
    TechnicalAssistanceName: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-():;,%#."/\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(200, 'Máximo 200 caracteres'),
    MainNeeds: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-():;,%#."/\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(1000, 'Máximo 1000 caracteres'),
    FacedLimitations: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-():;,%#."/\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(1000, 'Máximo 1000 caracteres'),
    IdentifiedProblemsImprove: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-():;,%#."/\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(1000, 'Máximo 1000 caracteres'),
    IdentifiedObstacles: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-():;,%#."/\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(1000, 'Máximo 1000 caracteres'),
    GeneralObjective: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-():;,%#."/\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(200, 'Máximo 200 caracteres'),
    SpecificObjective: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-():;,%#."/\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(500, 'Máximo 500 caracteres'),
    SpecificObjective2: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-():;,%#."/\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(500, 'Máximo 500 caracteres'),
    SpecificObjective3: Yup.string()
      .matches(
        /^[-():;,%#."/\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(500, 'Máximo 500 caracteres'),
    NecessaryImplementationActivities: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-():;,%#."/\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(1000, 'Máximo 1000 caracteres'),
    NumberOfParticipants: Yup.number()
      .required('Esta campo es obligatorio')
      .test(
        'superior',
        'El número de participantes debe ser mayor que 0',
        function (f) {
          const ref = 0
          return f > this.resolve(ref)
        },
      )
      .typeError('Esta campo es obligatorio'),
    ActionsForInclusionOfWomen: Yup.string()
      .required('Este campo es obligatorio')
      .matches(
        /^[-():;,%#."/\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        'Caracteres especiales no aceptados',
      )
      .max(1000, 'Máximo 1000 caracteres'),
    TrainedWomenNumber: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    TrainedMenNumber: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    TraineeAgeRange1: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    TraineeAgeRange2: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    TraineeAgeRange3: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    TraineeAgeRange4: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    TotalByGender: Yup.number().test(
      'superior',
      'El total de personas capacitadas por género y rango deben coincidir',
      function (f) {
        const ref = Yup.ref('TotalByRange')
        return f === this.resolve(ref)
      },
    ),
    TotalByRange: Yup.number().test(
      'superior',
      'El total de personas capacitadas por género y rango deben coincidir ',
      function (f) {
        const ref = Yup.ref('TotalByGender')
        return f === this.resolve(ref)
      },
    ),
    IndigenousCommunitiesNumber: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    validateTable272: Yup.boolean().oneOf(
      [true],
      'Los datos de esta tabla son obligatorios y el número de registros deben coincidir con el número de comunidades indígenas ',
    ),
    NumberOfStudies: Yup.number()
      .required('Este campo es obligatorio')
      .typeError('Este campo es obligatorio'),
    validateTable271: Yup.boolean().oneOf(
      [true],
      'Los datos de esta tabla son obligatorios y el número de registros deben coincidir con el número de estudios / evaluaciones ',
    ),
    validateTable25: Yup.boolean().oneOf(
      [true],
      'Los recursos de contrapartida deben ser como mínimo el 10% ',
    ),
    validatePresupuesto: Yup.boolean().oneOf(
      [true],
      'El total de Recursos CAMBIO II debe ser igual al monto de asistencia técnica solicitado ',
    ),
    StartExecutionPeriod: Yup.date().required('Este campo es obligatorio'),
    EndExecutionPeriod: Yup.date()
      .required('Este campo es obligatorio')
      .when(
        'StartExecutionPeriod',
        (StartExecutionPeriod, schema) =>
          StartExecutionPeriod &&
          schema.min(
            StartExecutionPeriod,
            'La fecha de finalizacion no puede ser menor a la fecha de inicio.',
          ),
      ),
    validateTable26: Yup.boolean().oneOf(
      [true],
      'Por favor, asegúrese de que la ejecución de las actividades, considere el inicio y fin previstos para la Asistencia Técnica',
    ),
  })

  const formik = useFormik({
    validateOnChange: false,

    initialValues: {
      TechnicalAssistanceName: assistanceForm.TechnicalAssistanceName || '',
      MainNeeds: assistanceForm.MainNeeds || '',
      FacedLimitations: assistanceForm.FacedLimitations || '',
      IdentifiedObstacles: assistanceForm.IdentifiedObstacles || '',
      GeneralObjective: assistanceForm.GeneralObjective || '',
      SpecificObjective: assistanceForm.SpecificObjective || '',
      SpecificObjective2: assistanceForm.SpecificObjective2 || '',
      SpecificObjective3: assistanceForm.SpecificObjective3 || '',
      NecessaryImplementationActivities:
        assistanceForm.NecessaryImplementationActivities || '',
      ActionsForInclusionOfWomen:
        assistanceForm.ActionsForInclusionOfWomen || '',
      StartExecutionPeriod: assistanceForm.StartExecutionPeriod
        ? Moment(assistanceForm.StartExecutionPeriod)
            .format('YYYY-MM-DD')
            .toString()
        : '',
      EndExecutionPeriod: assistanceForm.EndExecutionPeriod
        ? Moment(assistanceForm.EndExecutionPeriod)
            .format('YYYY-MM-DD')
            .toString()
        : '',
      NumberOfStudies: assistanceForm.NumberOfStudies || 0,
      TrainedWomenNumber:
        assistanceForm.TrainedWomenNumber === 0 ||
        assistanceForm.TrainedWomenNumber
          ? assistanceForm.TrainedWomenNumber
          : null,
      TrainedMenNumber:
        assistanceForm.TrainedMenNumber === 0 || assistanceForm.TrainedMenNumber
          ? assistanceForm.TrainedMenNumber
          : null,
      IdentifiedProblemsImprove: assistanceForm.IdentifiedProblemsImprove || '',
      NumberOfParticipants: assistanceForm.NumberOfParticipants || null,
      TraineeAgeRange1:
        assistanceForm.TraineeAgeRange1 === 0 || assistanceForm.TraineeAgeRange1
          ? assistanceForm.TraineeAgeRange1
          : null,
      TraineeAgeRange2:
        assistanceForm.TraineeAgeRange2 === 0 || assistanceForm.TraineeAgeRange2
          ? assistanceForm.TraineeAgeRange2
          : null,
      TraineeAgeRange3:
        assistanceForm.TraineeAgeRange3 === 0 || assistanceForm.TraineeAgeRange3
          ? assistanceForm.TraineeAgeRange3
          : null,
      TraineeAgeRange4:
        assistanceForm.TraineeAgeRange4 === 0 || assistanceForm.TraineeAgeRange4
          ? assistanceForm.TraineeAgeRange4
          : null,
      IndigenousCommunitiesNumber:
        assistanceForm.IndigenousCommunitiesNumber || 0,
      validatePresupuesto: false,
      validateTable26: false,
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      saveForm(values, false)
    },
  })

  console.log('validando ', assistanceForm.TraineeAgeRange1)
  console.log('validando ', formik.values.TraineeAgeRange1)

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const uploadReport = async (idForm, IdFormHistory) => {
    try {
      let response

      if (assistanceForm.IdBeneficiaryType === 2)
        response = await UploadReportCapacityBuildingIFI(
          idForm,
          userIDB2C,
          IdFormHistory,
        )

      if (
        assistanceForm.IdBeneficiaryType === 1 &&
        assistanceForm.IdTechnicalAssistanceType === 4
      )
        response = await UploadReportTechnicalAssistancePreinvestment(
          idForm,
          userIDB2C,
          IdFormHistory,
        )

      if (
        assistanceForm.IdBeneficiaryType === 3 &&
        assistanceForm.IdTechnicalAssistanceType === 4
      )
        response =
          await UploadReportTechnicalAssistancePreinvestmentGroupMipyme(
            idForm,
            userIDB2C,
            IdFormHistory,
          )

      if (
        assistanceForm.IdBeneficiaryType === 1 &&
        assistanceForm.IdTechnicalAssistanceType === 5
      )
        response = await UploadReportCapacityBuilding(
          idForm,
          userIDB2C,
          IdFormHistory,
        )

      if (
        assistanceForm.IdBeneficiaryType === 3 &&
        assistanceForm.IdTechnicalAssistanceType === 5
      )
        response = await UploadReportCapacityBuildingGroupMipyme(
          idForm,
          userIDB2C,
          IdFormHistory,
        )

      if (response.Success) {
        setSaving(false)
        swal({
          title: 'Formulario Enviado Exitosamente',
          icon: 'success',
          button: 'Entendido',
        })
        history.push('/')
      }
    } catch (error) {
      console.log(error)
    }
  }

  const saveForm = async (values, borrador, exit) => {
    try {
      setSaving(true)
      let object
      if (assistanceForm.IdBeneficiaryType !== 2 && !borrador) {
        object = {
          ...assistanceForm,
          ...values,
          Draft: false,
        }
      } else {
        object = {
          ...assistanceForm,
          ...values,
          StartExecutionPeriod:
            values.StartExecutionPeriod === ''
              ? null
              : values.StartExecutionPeriod,
          EndExecutionPeriod:
            values.EndExecutionPeriod === '' ? null : values.EndExecutionPeriod,
          NumberOfStudies:
            values.NumberOfStudies === '' ? null : values.NumberOfStudies,
        }
      }

      const response = await insertTechnicalAssistanceAnswers({ ...object })
      if (response.Success) {
        if (borrador) {
          setSaving(false)
          swal({
            title: 'Formulario Guardado',
            icon: 'success',
            button: 'Entendido',
          })
          if (exit) {
            if (edit) {
              history.push(ROUTES.IFIBORRADOR.pathname)
              dispatch({ type: 'SET_STATE', payload: 1 })
            } else {
              history.push('/')
              dispatch({ type: 'SET_STATE', payload: 1 })
            }
          }
        } else {
          if (assistanceForm.IdBeneficiaryType === 2) {
            next()
            saveValuesToContext(values)
            setSaving(false)
          } else {
            // swal({
            //   title: 'Formulario Enviado Exitosamente',
            //   icon: 'success',
            //   button: 'Entendido',
            // })
            // history.push('/')
            // dispatch({ type: 'SET_STATE', payload: 1 })
            uploadReport(
              response.Data.IdTechnicalAssistanceAnswersAnswer,
              response.Data.IdFormHistory,
            )
          }
        }
      }
    } catch (error) {
      console.log('Error al guardar', error)
    }
  }

  const saveValuesToContext = (values) => {
    setAssistanceForm((previous) => {
      const valuesSave = {
        TechnicalAssistanceName: values.TechnicalAssistanceName,
        MainNeeds: values.MainNeeds,
        FacedLimitations: values.FacedLimitations,
        IdentifiedProblemsImprove: values.IdentifiedProblemsImprove,
        IdentifiedObstacles: values.IdentifiedObstacles,
        GeneralObjective: values.GeneralObjective,
        SpecificObjective: values.SpecificObjective,
        SpecificObjective2: values.SpecificObjective2,
        SpecificObjective3: values.SpecificObjective3,
        NecessaryImplementationActivities:
          values.NecessaryImplementationActivities,
        NumberOfParticipants: values.NumberOfParticipants,
        ActionsForInclusionOfWomen: values.ActionsForInclusionOfWomen,
        TrainedWomenNumber: values.TrainedWomenNumber,
        TrainedMenNumber: values.TrainedMenNumber,
        TraineeAgeRange1: values.TraineeAgeRange1,
        TraineeAgeRange2: values.TraineeAgeRange2,
        TraineeAgeRange3: values.TraineeAgeRange3,
        TraineeAgeRange4: values.TraineeAgeRange4,
        IndigenousCommunitiesNumber: values.IndigenousCommunitiesNumber,
        NumberOfStudies: values.NumberOfStudies,
        StartExecutionPeriod: values.StartExecutionPeriod,
        EndExecutionPeriod: values.EndExecutionPeriod,
      }
      return {
        ...previous,
        ...valuesSave,
      }
    })
  }

  // Función para obtener la moneda por pais
  const getListCurrencyByCountry = async () => {
    try {
      const response = await getCurrencyByCountry(userCountry)
      if (response.Success) {
        setCurrencyType(response.Data)
      } else {
        throw Error(response.Message)
      }
    } catch (error) {
      console.log(error.message)
    }
  }

  useEffect(() => {
    getListCurrencyByCountry()
  }, [])

  return (
    <Grid>
      <Grid
        container
        md={12}
        sm={12}
        spacing={1}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Grid item>
          <div
            data-tip
            data-for="exitPop"
            onClick={() => cancelForm()}
            style={{
              backgroundColor: 'red',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <ExitIcon style={{ transform: 'scaleX(-1)' }} />
            <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
              <span>Regresar</span>
            </ReactTooltip>
          </div>
        </Grid>
        <Grid item>
          <div
            onClick={() => saveForm(formik.values, true)}
            data-tip
            data-for="savePop"
            style={{
              backgroundColor: '#5cb85c',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <SaveIcon />
          </div>
          <ReactTooltip id="savePop" effect="solid" backgroundColor="#5cb85c">
            <span>Guardar Borrador</span>
          </ReactTooltip>
        </Grid>
      </Grid>

      <form id="transfers-form">
        <Grid item xs={12} sm={12} md={12}>
          <h1 className="h1text">
            Información sobre la Asistencia Técnica solicitada
          </h1>
          <br />
        </Grid>

        <Grid
          container
          spacing={1}
          className="input__container"
          style={{ marginBottom: '3%' }}
        >
          <Grid item xs={12} sm={12} md={12}>
            <label className="responsiveLabel">
              <b> 1. Nombre de la asistencia técnica </b>
              {''}
              <span style={{ color: 'red' }}>*</span>
            </label>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <FormControl style={{ width: '100%' }}>
              <TextField
                id="IdCurrencyUser"
                name="IdCurrencyUser"
                style={{ width: '100%' }}
                variant="outlined"
                value={formik.values.TechnicalAssistanceName}
                onChange={(e) => {
                  formik.setFieldValue(
                    'TechnicalAssistanceName',
                    e.target.value,
                  )
                }}
                inputProps={{
                  maxLength: 200,
                }}
                error={formik.errors.TechnicalAssistanceName}
              />
              {formik.errors.TechnicalAssistanceName ? (
                <div
                  style={{
                    color: 'red',
                    marginTop: '3px',
                    fontSize: '13px',
                  }}
                >
                  {formik.errors.TechnicalAssistanceName}
                </div>
              ) : null}
            </FormControl>
          </Grid>
        </Grid>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={
              formik.errors.MainNeeds ||
              formik.errors.FacedLimitations ||
              formik.errors.IdentifiedProblemsImprove ||
              formik.errors.IdentifiedObstacles
                ? { border: '2px solid red' }
                : {}
            }
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              2. Justificación, principales necesidades y limitaciones de línea
              base
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Por favor, brinde información sobre la justificación para
                  solicitar la asistencia técnica.
                </label>
              </Grid>

              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    2.1. Principales necesidades:{' '}
                    <span style={{ color: 'red' }}>*</span>
                    <a
                      data-tip="Los caracteres especiales permitidos son: Dos Puntos, punto y coma, punto, coma, guion, diéresis, tildes, numeral, paréntesis, porcentaje y comillas."
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Describa las necesidades que tiene la MIPYME, y que le
                    impiden/reducen su desarrollo y crecimiento (desafíos para
                    el desarrollo de su negocio, la implementación de medidas de
                    mitigación del impacto ambiental y de adaptación al cambio
                    climático, la incorporación de mujeres y/o jóvenes; entre
                    otros)
                  </label>
                  <br></br>
                  <br></br>
                </Grid>

                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder="Principales necesidades"
                      customInput={TextField}
                      value={formik.values.MainNeeds}
                      onChange={(e) => {
                        if (
                          e.target.value.match(
                            /[-:.;,%#()"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                          ) ||
                          e.target.value === ''
                        ) {
                          setErrorNecesidades(false)
                          formik.setFieldValue('MainNeeds', e.target.value)
                        } else {
                          setErrorNecesidades(true)
                        }
                      }}
                      maxLength={1000}
                    ></textarea>
                    {errorNecesidades ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        Caracteres especiales no aceptados
                      </div>
                    ) : null}
                    {formik.errors.MainNeeds ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.MainNeeds}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    2.2. Limitaciones enfrentadas:{' '}
                    <span style={{ color: 'red' }}>*</span>
                    <a
                      data-tip="Los caracteres especiales permitidos son: Dos Puntos, punto y coma, punto, coma, guion, diéresis, tildes, numeral, paréntesis, porcentaje y comillas."
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Explique cuáles son los aspectos o circunstancias que le
                    limitan/impiden solucionar los problemas identificados, por
                    los que solicita la Asistencia Técnica. Se entienden como
                    limitación, un factor que reduce la
                    productividad/rentabilidad de la MIPYME
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder="Limitaciones enfrentadas"
                      customInput={TextField}
                      value={formik.values.FacedLimitations}
                      onChange={(e) => {
                        if (
                          e.target.value.match(
                            /[-:.;,%#()"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                          ) ||
                          e.target.value === ''
                        ) {
                          setErrorLimitaciones(false)
                          formik.setFieldValue(
                            'FacedLimitations',
                            e.target.value,
                          )
                        } else {
                          setErrorLimitaciones(true)
                        }
                      }}
                      maxLength={1000}
                    ></textarea>
                    {errorLimitaciones ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        Caracteres especiales no aceptados
                      </div>
                    ) : null}
                    {formik.errors.FacedLimitations ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.FacedLimitations}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    2.3. Defina los problemas identificados que se pretende
                    mejorar: <span style={{ color: 'red' }}>*</span>
                    <a
                      data-tip="Los caracteres especiales permitidos son: Dos Puntos, punto y coma, punto, coma, guion, diéresis, tildes, numeral, paréntesis, porcentaje y comillas."
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Detalle, cuáles de los problemas identificados desea atender
                    para mejorar o solucionar la situación que quiere resolver
                    mediante la ejecución de la Asistencia Técnica. Se entiende
                    como problema, un factor que entorpece la operación de la
                    MIPYME
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder="Problemas identificados"
                      customInput={TextField}
                      value={formik.values.IdentifiedProblemsImprove}
                      onChange={(e) => {
                        if (
                          e.target.value.match(
                            /[-:.;,%#()"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                          ) ||
                          e.target.value === ''
                        ) {
                          setErrorProblemas(false)
                          formik.setFieldValue(
                            'IdentifiedProblemsImprove',
                            e.target.value,
                          )
                        } else {
                          setErrorProblemas(true)
                        }
                      }}
                      maxLength={1000}
                    ></textarea>
                    {errorProblemas ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        Caracteres especiales no aceptados
                      </div>
                    ) : null}
                    {formik.errors.IdentifiedProblemsImprove ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.IdentifiedProblemsImprove}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    2.4. Obstáculos identificados, para la implementación
                    exitosa del subproyecto:{' '}
                    <span style={{ color: 'red' }}>*</span>
                    <a
                      data-tip="Los caracteres especiales permitidos son: Dos Puntos, punto y coma, punto, coma, guion, diéresis, tildes, numeral, paréntesis, porcentaje y comillas."
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Explique cuáles son los obstáculos que desea
                    reducir/eliminar y que le permitirá ejecutar el subproyecto
                    para el cual recibirá/ha recibido un crédito. Se entiende
                    como obstáculo, un factor que detiene a la MIPYME.
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder="Obstáculos identificados"
                      customInput={TextField}
                      value={formik.values.IdentifiedObstacles}
                      onChange={(e) => {
                        if (
                          e.target.value.match(
                            /[-:.;,%#()"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                          ) ||
                          e.target.value === ''
                        ) {
                          setErrorObstaculos(false)
                          formik.setFieldValue(
                            'IdentifiedObstacles',
                            e.target.value,
                          )
                        } else {
                          setErrorObstaculos(true)
                        }
                      }}
                      maxLength={1000}
                    ></textarea>
                    {errorObstaculos ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        Caracteres especiales no aceptados
                      </div>
                    ) : null}
                    {formik.errors.IdentifiedObstacles ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.IdentifiedObstacles}
                      </div>
                    ) : null}
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={
              formik.errors.GeneralObjective ||
              formik.errors.SpecificObjective ||
              formik.errors.SpecificObjective2 ||
              formik.errors.SpecificObjective3
                ? { border: '2px solid red' }
                : {}
            }
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              3. Objetivos principales de la asistencia técnica
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Proporcione un objetivo general y mínimo dos objetivos
                  específicos (máximo 3) de la asistencia técnica.
                </label>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    3.1. Objetivo general:{' '}
                    <span style={{ color: 'red' }}>*</span>
                    <a
                      data-tip="Los caracteres especiales permitidos son: Dos Puntos, punto y coma, punto, coma, guion, diéresis, tildes, numeral, paréntesis, porcentaje y comillas."
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Definir de la forma más clara posible, el resultado que se
                    desea alcanzar por medio de la asistencia técnica.
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder="Objetivo general"
                      customInput={TextField}
                      value={formik.values.GeneralObjective}
                      onChange={(e) => {
                        if (
                          e.target.value.match(
                            /[-:.;,%#()"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                          ) ||
                          e.target.value === ''
                        ) {
                          setErrorObjetivo(false)
                          formik.setFieldValue(
                            'GeneralObjective',
                            e.target.value,
                          )
                        } else {
                          setErrorObjetivo(true)
                        }
                      }}
                      maxLength={200}
                    ></textarea>
                    {errorObjetivo ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        Caracteres especiales no aceptados
                      </div>
                    ) : null}
                  </FormControl>
                  {formik.errors.GeneralObjective ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.GeneralObjective}
                    </div>
                  ) : null}
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    3.2. Objetivo específico I:{' '}
                    <span style={{ color: 'red' }}>*</span>
                    <a
                      data-tip="Los caracteres especiales permitidos son: Dos Puntos, punto y coma, punto, coma, guion, diéresis, tildes, numeral, paréntesis, porcentaje y comillas."
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Definir un paso necesario (de tipo técnico, financiero,
                    productivo y/o comercial) para alcanzar el objetivo general
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder="Objetivo específico"
                      customInput={TextField}
                      value={formik.values.SpecificObjective}
                      onChange={(e) => {
                        if (
                          e.target.value.match(
                            /[-:.;,%#()"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                          ) ||
                          e.target.value === ''
                        ) {
                          setErrorEspecificoI(false)
                          formik.setFieldValue(
                            'SpecificObjective',
                            e.target.value,
                          )
                        } else {
                          setErrorEspecificoI(true)
                        }
                      }}
                      maxLength={500}
                    ></textarea>
                    {errorEspecificoI ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        Caracteres especiales no aceptados
                      </div>
                    ) : null}
                  </FormControl>
                  {formik.errors.SpecificObjective ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.SpecificObjective}
                    </div>
                  ) : null}
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    3.3. Objetivo específico II:{' '}
                    <span style={{ color: 'red' }}>*</span>
                    <a
                      data-tip="Los caracteres especiales permitidos son: Dos Puntos, punto y coma, punto, coma, guion, diéresis, tildes, numeral, paréntesis, porcentaje y comillas."
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Definir un paso necesario (de tipo técnico, financiero,
                    productivo y/o comercial) para alcanzar el objetivo general
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder="Objetivo específico"
                      customInput={TextField}
                      value={formik.values.SpecificObjective2}
                      onChange={(e) => {
                        if (
                          e.target.value.match(
                            /[-:.;,%#()"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                          ) ||
                          e.target.value === ''
                        ) {
                          setErrorEspecificoII(false)
                          formik.setFieldValue(
                            'SpecificObjective2',
                            e.target.value,
                          )
                        } else {
                          setErrorEspecificoII(true)
                        }
                      }}
                      maxLength={500}
                    ></textarea>
                    {errorEspecificoII ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        Caracteres especiales no aceptados
                      </div>
                    ) : null}
                  </FormControl>
                  {formik.errors.SpecificObjective2 ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.SpecificObjective2}
                    </div>
                  ) : null}
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    3.4. Objetivo específico III:
                  </label>
                  <a
                    data-tip="Los caracteres especiales permitidos son: Dos Puntos, punto y coma, punto, coma, guion, diéresis, tildes, numeral, paréntesis, porcentaje y comillas."
                    data-for="infoCurrencyPop"
                    style={{ cursor: 'pointer' }}
                  >
                    <ErrorOutlineIcon fontSize="small" />
                    <ReactTooltip
                      id="infoCurrencyPop"
                      effect="solid"
                      multiline={true}
                      type="dark"
                    />
                  </a>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Definir un paso necesario (de tipo técnico, financiero,
                    productivo y/o comercial) para alcanzar el objetivo general.
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder="Objetivo específico"
                      customInput={TextField}
                      value={formik.values.SpecificObjective3}
                      onChange={(e) => {
                        if (
                          e.target.value.match(
                            /[-:.;,%#()"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                          ) ||
                          e.target.value === ''
                        ) {
                          setErrorEspecificoIII(false)
                          formik.setFieldValue(
                            'SpecificObjective3',
                            e.target.value,
                          )
                        } else {
                          setErrorEspecificoIII(true)
                        }
                      }}
                      maxLength={500}
                    ></textarea>
                    {errorEspecificoIII ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        Caracteres especiales no aceptados
                      </div>
                    ) : null}
                  </FormControl>
                  {formik.errors.SpecificObjective3 ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.SpecificObjective3}
                    </div>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={
              formik.errors.NecessaryImplementationActivities ||
              formik.errors.NumberOfParticipants ||
              formik.errors.ActionsForInclusionOfWomen
                ? { border: '2px solid red' }
                : {}
            }
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              4. Descripción técnica de la asistencia solicitada
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Proporcione una descripción detallada de la asistencia técnica
                  requerida.
                </label>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    4.1. Modalidad de apoyo:
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <TextField
                      id="IdCurrencyUser"
                      name="IdCurrencyUser"
                      style={{ width: '100%' }}
                      variant="outlined"
                      disabled
                      value={
                        assistanceForm.IdTechnicalAssistanceType === 4
                          ? 'Asistencia técnica para pre-inversión de MIPYME'
                          : assistanceForm.IdTechnicalAssistanceType === 5
                          ? 'Construcción de capacidades para MIPYME'
                          : assistanceForm.IdTechnicalAssistanceType === 3
                          ? 'Construcción de capacidades para IFI'
                          : ''
                      }
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    4.2. Actividades necesarias para su implementación:{' '}
                    <span style={{ color: 'red' }}>*</span>
                    <a
                      data-tip="Los caracteres especiales permitidos son: Dos Puntos, punto y coma, punto, coma, guion, diéresis, tildes, numeral, paréntesis, porcentaje y comillas."
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Detalle las actividades requeridas para ejecutar la
                    Asistencia Técnica (Ejem: 1. Diseño de Términos de
                    Referencia, 2. Contratación de consultor, 3. Diseño y
                    desarrollo de capacitación, 4. Informe final de la
                    actividad)
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder=" Actividades necesarias"
                      customInput={TextField}
                      value={formik.values.NecessaryImplementationActivities}
                      onChange={(e) => {
                        if (
                          e.target.value.match(
                            /[-:.;,%#()"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                          ) ||
                          e.target.value === ''
                        ) {
                          setErrorActividades(false)
                          formik.setFieldValue(
                            'NecessaryImplementationActivities',
                            e.target.value,
                          )
                        } else {
                          setErrorActividades(true)
                        }
                      }}
                      maxLength={1000}
                    ></textarea>
                    {errorActividades ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        Caracteres especiales no aceptados
                      </div>
                    ) : null}
                  </FormControl>
                  {formik.errors.NecessaryImplementationActivities ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.NecessaryImplementationActivities}
                    </div>
                  ) : null}
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    4.3. Número de participantes:{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Indique el número de personas que participarán en la
                    asistencia técnica (Ejem: número de personas capacitadas,
                    número de personas que apoyarán la Asistencia Técnica como
                    contraparte de la empresa).
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <NumberFormat
                      id="numberAss"
                      style={{ width: '100%' }}
                      customInput={TextField}
                      thousandSeparator={true}
                      variant="outlined"
                      allowNegative={false}
                      onChange={(e) => {
                        formik.setFieldValue(
                          'NumberOfParticipants',
                          Number(e.target.value.replaceAll(',', '')),
                        )
                      }}
                      error={formik.errors.NumberOfParticipants}
                      value={formik.values.NumberOfParticipants}
                      inputProps={{ maxLength: 4 }}
                      decimalScale={0}
                      allowLeadingZeros={false}
                    />
                  </FormControl>
                  {formik.errors.NumberOfParticipants ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.NumberOfParticipants}
                    </div>
                  ) : null}
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    4.4. Acciones para inclusión de mujeres:{' '}
                    <span style={{ color: 'red' }}>*</span>
                    <a
                      data-tip="Los caracteres especiales permitidos son: Dos Puntos, punto y coma, punto, coma, guion, diéresis, tildes, numeral, paréntesis, porcentaje y comillas."
                      data-for="infoCurrencyPop"
                      style={{ cursor: 'pointer' }}
                    >
                      <ErrorOutlineIcon fontSize="small" />
                      <ReactTooltip
                        id="infoCurrencyPop"
                        effect="solid"
                        multiline={true}
                        type="dark"
                      />
                    </a>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Describa las acciones que se tomarán para asegurar la
                    participación de mujeres en las actividades por desarrollar.
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <FormControl style={{ width: '100%' }}>
                    <textarea
                      placeholder="Acciones para inclusión de mujeres"
                      customInput={TextField}
                      value={formik.values.ActionsForInclusionOfWomen}
                      onChange={(e) => {
                        if (
                          e.target.value.match(
                            /[-:.;,%#()"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
                          ) ||
                          e.target.value === ''
                        ) {
                          setErrorAcciones(false)
                          formik.setFieldValue(
                            'ActionsForInclusionOfWomen',
                            e.target.value,
                          )
                        } else {
                          setErrorAcciones(true)
                        }
                      }}
                      maxLength={1000}
                    ></textarea>
                  </FormControl>
                  {errorAcciones ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      Caracteres especiales no aceptados
                    </div>
                  ) : null}
                  {formik.errors.ActionsForInclusionOfWomen ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.ActionsForInclusionOfWomen}
                    </div>
                  ) : null}
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={
              formik.errors.validateTable25 || formik.errors.validatePresupuesto
                ? { border: '2px solid red' }
                : {}
            }
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              5. Presupuesto desglosado
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} style={{ alignItems: 'center' }}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Para cada rubro (solamente los que se asocien con la ejecución
                  de la Asistencia Técnica solicitada), desglose el monto
                  requerido con fondos CAMBIO, y con fondos de contraparte.
                </label>
                <br></br>
                <br></br>
              </Grid>
              <Grid item xs={3} sm={3} md={3} className="input__container">
                <label>5.1. Moneda:</label>
              </Grid>
              <Grid item xs={4} sm={4} md={4}>
                <FormControl fullWidth>
                  {assistanceForm.IdCurrency === null ||
                  assistanceForm.IdCurrency === '' ||
                  assistanceForm.IdCurrency === undefined ? null : (
                    <Select
                      id="IdProject"
                      name="IdProject"
                      variant="outlined"
                      value={assistanceForm.IdCurrency}
                      disabled
                    >
                      <MenuItem disabled value="">
                        Seleccione una opción
                      </MenuItem>
                      {currencyType &&
                        currencyType.map((item) => (
                          <MenuItem
                            key={item.IdCurrency}
                            value={item.IdCurrency}
                          >
                            {item.Description}
                          </MenuItem>
                        ))}
                    </Select>
                  )}
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12} md={12}>
                <Table25
                  IdCurrency={assistanceForm.IdCurrency}
                  IdTechnicalAssistanceAnswer={
                    assistanceForm.IdTechnicalAssistanceAnswer
                  }
                  formik={formik.setFieldValue}
                />

                {formik.errors.validateTable25 ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.validateTable25}
                  </div>
                ) : null}
                {formik.errors.validatePresupuesto ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.validatePresupuesto}
                  </div>
                ) : null}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={
              formik.errors.StartExecutionPeriod ||
              formik.errors.EndExecutionPeriod
                ? { border: '2px solid red' }
                : {}
            }
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              6. Cronograma de ejecución previsto
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} className="input__container">
                <label className="responsiveLabel">
                  6.1. Período estimado de ejecución{' '}
                  <span style={{ color: 'red' }}>*</span>
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Establezca el periodo de tiempo que se estima para ejecutar
                  cada una de las actividades de las actividades definidas para
                  ejecutar la Asistencia (Ejem: 1. Diseño de Términos de
                  Referencia, 2. Contratación de consultor, 3. Diseño y
                  desarrollo de capacitación, 4. Informe final de la actividad)
                </label>
                <br></br>
                <br></br>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <FormControl style={{ width: '100%' }}>
                  <Stack component="form" noValidate spacing={3}>
                    <TextField
                      id="date"
                      label="Desde"
                      type="date"
                      variant="outlined"
                      sx={{ width: 220 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={formik.values.StartExecutionPeriod}
                      onChange={(e) => {
                        formik.setFieldValue(
                          'StartExecutionPeriod',
                          e.target.value,
                        )
                        formik.setFieldValue('EndExecutionPeriod', '')
                      }}
                      error={formik.errors.StartExecutionPeriod}
                    />
                  </Stack>
                  {formik.errors.StartExecutionPeriod ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.StartExecutionPeriod}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6} md={6}>
                <FormControl style={{ width: '100%' }}>
                  <Stack component="form" noValidate spacing={3}>
                    <TextField
                      id="date"
                      label="Hasta"
                      type="date"
                      variant="outlined"
                      sx={{ width: 220 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        min: formik.values.StartExecutionPeriod,
                      }}
                      value={formik.values.EndExecutionPeriod}
                      disabled={formik.values.StartExecutionPeriod === ''}
                      onChange={(e) => {
                        formik.setFieldValue(
                          'EndExecutionPeriod',
                          e.target.value,
                        )
                      }}
                      error={formik.errors.EndExecutionPeriod}
                    />
                  </Stack>
                  {formik.errors.EndExecutionPeriod ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.EndExecutionPeriod}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={12} md={12} className="input__container">
                <label className="responsiveLabel">
                  6.2. Marque en el cronograma los meses en que se estima se
                  implementará la asistencia técnica de acuerdo con cada
                  actividad principal <span style={{ color: 'red' }}>*</span>
                </label>
                <br></br>
                <br></br>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Para la definición de las fechas de inicio y de fin, tome en
                  cuenta que estas se enmarquen en el periodo de implementación
                  del proyecto de Asistencia Técnica
                </label>
                <br></br>
                <br></br>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                {/* Cronograma */}
                <Table26
                  IdTechnicalAssistanceAnswer={
                    assistanceForm.IdTechnicalAssistanceAnswer
                  }
                  StartExecutionPeriod={formik.values.StartExecutionPeriod}
                  EndExecutionPeriod={formik.values.EndExecutionPeriod}
                  formikSec={formik.setFieldValue}
                />
                {formik.errors.validateTable26 ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.validateTable26}
                  </div>
                ) : null}
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            sx={
              formik.errors.NumberOfStudies ||
              formik.errors.validateTable271 ||
              formik.errors.TrainedWomenNumber ||
              formik.errors.TrainedMenNumber ||
              formik.errors.TotalByGender ||
              formik.errors.TraineeAgeRange1 ||
              formik.errors.TraineeAgeRange2 ||
              formik.errors.TraineeAgeRange3 ||
              formik.errors.TraineeAgeRange4 ||
              formik.errors.TotalByRange ||
              formik.errors.IndigenousCommunitiesNumber ||
              formik.errors.validateTable272
                ? { border: '2px solid red' }
                : {}
            }
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              7. Productos esperados
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Indique los productos que espera obtener como resultado de la
                  ejecución de la Asistencia Técnica.
                </label>
                <br></br>
                <br></br>
              </Grid>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    className="input__container"
                  >
                    <label className="responsiveLabel">
                      7.1. Número de estudios / evaluaciones{' '}
                      <span style={{ color: 'red' }}>*</span>
                    </label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      Si los productos incluyen estudios y/o evaluaciones,
                      indique el número de estos que resultarán de la ejecución
                      de la Asistencia Técnica. Si se trata de un proyecto de
                      capacitación, escriba 0
                    </label>
                    <br></br>
                    <br></br>
                  </Grid>
                  <Grid item xs={12} sm={4} md={4}>
                    <FormControl fullWidth>
                      <NumberFormat
                        id="numberAss"
                        style={{ width: '100%' }}
                        customInput={TextField}
                        thousandSeparator={true}
                        variant="outlined"
                        allowNegative={false}
                        onChange={(e) => {
                          formik.setFieldValue(
                            'NumberOfStudies',
                            Number(e.target.value.replaceAll(',', '')),
                          )
                        }}
                        error={formik.errors.NumberOfStudies}
                        value={formik.values.NumberOfStudies}
                        inputProps={{ maxLength: 2 }}
                        allowLeadingZeros={false}
                      />
                    </FormControl>
                    {formik.errors.NumberOfStudies ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.NumberOfStudies}
                      </div>
                    ) : null}
                  </Grid>{' '}
                </Grid>

                <Grid
                  container
                  spacing={1}
                  className="input__container"
                  style={{ marginBottom: '3%' }}
                >
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      <b>Descripción:</b> Describa los estudios y/o evaluaciones
                      que resultarán de la ejecución de la Asistencia Técnica.
                    </label>
                    <br></br>
                    <br></br>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <Table271
                      IdTechnicalAssistanceAnswer={
                        assistanceForm.IdTechnicalAssistanceAnswer
                      }
                      NumberOfStudies={formik.values.NumberOfStudies}
                      formik={formik.setFieldValue}
                    />
                    {formik.errors.validateTable271 ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.validateTable271}
                      </div>
                    ) : null}
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <label className="responsiveLabel">
                    7.2. Números de personas capacitadas por género{' '}
                    <span style={{ color: 'red' }}>*</span>
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <label className="responsiveLabel">
                    Si la Asistencia Técnica se relaciona con un proyecto de
                    capacitación, indique el número de personas que serán
                    capacitadas, desglosando por número de mujeres y número de
                    hombres
                  </label>
                  <br></br>
                  <br></br>
                </Grid>
                <Grid
                  container
                  spacing={1}
                  style={{
                    marginTop: '1%',
                    paddingLeft: '3%',
                  }}
                >
                  <Grid item xs={3} sm={3} md={3} style={{ marginTop: '1%' }}>
                    <label className="responsiveLabel">
                      1. Número de mujeres:
                    </label>
                  </Grid>
                  <Grid item xs={3} sm={3} md={3}>
                    <FormControl style={{ width: '100%' }}>
                      <NumberFormat
                        id="fullName"
                        style={{ width: '100%' }}
                        allowNegative={false}
                        customInput={TextField}
                        variant="outlined"
                        onChange={(e) => {
                          formik.setFieldValue(
                            'TrainedWomenNumber',
                            Number(e.target.value.replaceAll(',', '')),
                          )

                          formik.setFieldValue(
                            'TotalByGender',
                            Number(e.target.value.replaceAll(',', '')) +
                              formik.values.TrainedMenNumber,
                          )
                        }}
                        error={formik.errors.TrainedWomenNumber}
                        value={formik.values.TrainedWomenNumber}
                        inputProps={{ maxLength: 4 }}
                        decimalScale={0}
                        allowLeadingZeros={false}
                      />
                    </FormControl>
                    {formik.errors.TrainedWomenNumber ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.TrainedWomenNumber}
                      </div>
                    ) : null}
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={1}
                  style={{
                    marginTop: '1%',
                    paddingLeft: '3%',
                  }}
                >
                  <Grid item xs={3} sm={3} md={3} style={{ marginTop: '1%' }}>
                    <label className="responsiveLabel">
                      2. Número de hombres:
                    </label>
                  </Grid>
                  <Grid item xs={3} sm={3} md={3}>
                    <FormControl style={{ width: '100%' }}>
                      <NumberFormat
                        id="fullName"
                        style={{ width: '100%' }}
                        allowNegative={false}
                        customInput={TextField}
                        variant="outlined"
                        onChange={(e) => {
                          formik.setFieldValue(
                            'TrainedMenNumber',
                            Number(e.target.value.replaceAll(',', '')),
                          )

                          formik.setFieldValue(
                            'TotalByGender',
                            Number(e.target.value.replaceAll(',', '')) +
                              formik.values.TrainedWomenNumber,
                          )
                        }}
                        error={formik.errors.TrainedMenNumber}
                        value={formik.values.TrainedMenNumber}
                        inputProps={{ maxLength: 4 }}
                        decimalScale={0}
                        allowLeadingZeros={false}
                      />
                    </FormControl>
                    {formik.errors.TrainedMenNumber ? (
                      <div
                        style={{
                          color: 'red',
                          marginTop: '3px',
                          fontSize: '13px',
                        }}
                      >
                        {formik.errors.TrainedMenNumber}
                      </div>
                    ) : null}
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={1}
                  style={{
                    marginTop: '1%',
                    paddingLeft: '3%',
                  }}
                >
                  <Grid item xs={3} sm={3} md={3} style={{ marginTop: '1%' }}>
                    <label className="responsiveLabel">
                      <b>Total de personas capacitadas por género:</b>
                    </label>
                  </Grid>
                  <Grid item xs={3} sm={3} md={3}>
                    <FormControl style={{ width: '100%' }}>
                      <NumberFormat
                        id="fullName"
                        style={{ width: '100%' }}
                        allowNegative={false}
                        customInput={TextField}
                        variant="outlined"
                        value={
                          formik.values.TrainedWomenNumber +
                          formik.values.TrainedMenNumber
                        }
                        disabled
                        error={formik.errors.TotalByGender}
                        allowLeadingZeros={false}
                      />
                      {formik.errors.TotalByGender ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.TotalByGender}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={1}>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    className="input__container"
                  >
                    <label className="responsiveLabel">
                      7.3. Números de personas capacitadas por rango de edad{' '}
                      <span style={{ color: 'red' }}>*</span>
                    </label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      Si la Asistencia Técnica se relaciona con un proyecto de
                      capacitación, indique el número de personas que serán
                      capacitadas, desglosando por el rango de edad (18-30 /
                      31-45 / 46-60 / 61- Adelante).
                    </label>
                    <br></br>
                    <br></br>
                  </Grid>

                  <Grid
                    container
                    spacing={1}
                    style={{
                      marginTop: '1%',
                      paddingLeft: '3%',
                    }}
                  >
                    <Grid item xs={3} sm={3} md={3} style={{ marginTop: '1%' }}>
                      <label className="responsiveLabel">18-30:</label>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <FormControl style={{ width: '100%' }}>
                        <NumberFormat
                          id="fullName"
                          style={{ width: '100%' }}
                          allowNegative={false}
                          customInput={TextField}
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue(
                              'TraineeAgeRange1',
                              Number(e.target.value.replaceAll(',', '')),
                            )

                            formik.setFieldValue(
                              'TotalByRange',
                              Number(e.target.value.replaceAll(',', '')) +
                                formik.values.TraineeAgeRange2 +
                                formik.values.TraineeAgeRange3 +
                                formik.values.TraineeAgeRange4,
                            )
                          }}
                          error={formik.errors.TraineeAgeRange1}
                          value={formik.values.TraineeAgeRange1}
                          inputProps={{ maxLength: 4 }}
                          decimalScale={0}
                          allowLeadingZeros={false}
                        />
                      </FormControl>
                      {formik.errors.TraineeAgeRange1 ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.TraineeAgeRange1}
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={1}
                    style={{
                      marginTop: '1%',
                      paddingLeft: '3%',
                    }}
                  >
                    <Grid item xs={3} sm={3} md={3} style={{ marginTop: '1%' }}>
                      <label className="responsiveLabel">31-45:</label>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <FormControl style={{ width: '100%' }}>
                        <NumberFormat
                          id="fullName"
                          style={{ width: '100%' }}
                          allowNegative={false}
                          allowLeadingZeros={false}
                          customInput={TextField}
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue(
                              'TraineeAgeRange2',
                              Number(e.target.value.replaceAll(',', '')),
                            )

                            formik.setFieldValue(
                              'TotalByRange',
                              Number(e.target.value.replaceAll(',', '')) +
                                formik.values.TraineeAgeRange1 +
                                formik.values.TraineeAgeRange3 +
                                formik.values.TraineeAgeRange4,
                            )
                          }}
                          error={formik.errors.TraineeAgeRange2}
                          value={formik.values.TraineeAgeRange2}
                          inputProps={{ maxLength: 4 }}
                          decimalScale={0}
                        />
                      </FormControl>
                      {formik.errors.TraineeAgeRange2 ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.TraineeAgeRange2}
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={1}
                    style={{
                      marginTop: '1%',
                      paddingLeft: '3%',
                    }}
                  >
                    <Grid item xs={3} sm={3} md={3} style={{ marginTop: '1%' }}>
                      <label className="responsiveLabel">46-60:</label>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <FormControl style={{ width: '100%' }}>
                        <NumberFormat
                          id="fullName"
                          style={{ width: '100%' }}
                          allowLeadingZeros={false}
                          allowNegative={false}
                          customInput={TextField}
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue(
                              'TraineeAgeRange3',
                              Number(e.target.value.replaceAll(',', '')),
                            )

                            formik.setFieldValue(
                              'TotalByRange',
                              Number(e.target.value.replaceAll(',', '')) +
                                formik.values.TraineeAgeRange2 +
                                formik.values.TraineeAgeRange1 +
                                formik.values.TraineeAgeRange4,
                            )
                          }}
                          error={formik.errors.TraineeAgeRange3}
                          value={formik.values.TraineeAgeRange3}
                          inputProps={{ maxLength: 4 }}
                          decimalScale={0}
                        />
                      </FormControl>
                      {formik.errors.TraineeAgeRange3 ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.TraineeAgeRange3}
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={1}
                    style={{
                      marginTop: '1%',
                      paddingLeft: '3%',
                    }}
                  >
                    <Grid item xs={3} sm={3} md={3} style={{ marginTop: '1%' }}>
                      <label className="responsiveLabel">61- Adelante:</label>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <FormControl style={{ width: '100%' }}>
                        <NumberFormat
                          id="fullName"
                          style={{ width: '100%' }}
                          allowLeadingZeros={false}
                          allowNegative={false}
                          customInput={TextField}
                          variant="outlined"
                          onChange={(e) => {
                            formik.setFieldValue(
                              'TraineeAgeRange4',
                              Number(e.target.value.replaceAll(',', '')),
                            )

                            formik.setFieldValue(
                              'TotalByRange',
                              Number(e.target.value.replaceAll(',', '')) +
                                formik.values.TraineeAgeRange2 +
                                formik.values.TraineeAgeRange3 +
                                formik.values.TraineeAgeRange1,
                            )
                          }}
                          error={formik.errors.TraineeAgeRange4}
                          value={formik.values.TraineeAgeRange4}
                          inputProps={{ maxLength: 4 }}
                          decimalScale={0}
                        />
                      </FormControl>
                      {formik.errors.TraineeAgeRange4 ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.TraineeAgeRange4}
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>

                  <Grid
                    container
                    spacing={1}
                    style={{
                      marginTop: '1%',
                      paddingLeft: '3%',
                    }}
                  >
                    <Grid item xs={3} sm={3} md={3} style={{ marginTop: '1%' }}>
                      <label className="responsiveLabel">
                        <b>Total de personas capacitadas por rango de edad:</b>
                      </label>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3}>
                      <FormControl style={{ width: '100%' }}>
                        <NumberFormat
                          id="fullName"
                          allowNegative={false}
                          customInput={TextField}
                          variant="outlined"
                          inputProps={{ maxLength: 4 }}
                          disabled
                          decimalScale={0}
                          value={
                            formik.values.TraineeAgeRange2 +
                            formik.values.TraineeAgeRange3 +
                            formik.values.TraineeAgeRange1 +
                            formik.values.TraineeAgeRange4
                          }
                          error={formik.errors.TotalByRange}
                          allowLeadingZeros={false}
                        />
                        {formik.errors.TotalByRange ? (
                          <div
                            style={{
                              color: 'red',
                              marginTop: '3px',
                              fontSize: '13px',
                            }}
                          >
                            {formik.errors.TotalByRange}
                          </div>
                        ) : null}
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid container spacing={1} className="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      7.4. Comunidades indígenas representadas:
                    </label>
                  </Grid>

                  <Grid container spacing={1} style={{ marginBottom: '2%' }}>
                    <Grid item xs={4} sm={4} md={4}>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        className="input__container"
                      >
                        <label className="responsiveLabel">
                          Número de comunidades indígenas representadas{' '}
                          <span style={{ color: 'red' }}>*</span>
                        </label>
                      </Grid>

                      <FormControl fullWidth>
                        <NumberFormat
                          id="numberAss"
                          allowLeadingZeros={false}
                          style={{ width: '100%' }}
                          customInput={TextField}
                          thousandSeparator={true}
                          variant="outlined"
                          allowNegative={false}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'IndigenousCommunitiesNumber',
                              Number(e.target.value.replaceAll(',', '')),
                            )
                          }}
                          error={formik.errors.IndigenousCommunitiesNumber}
                          value={formik.values.IndigenousCommunitiesNumber}
                          inputProps={{ maxLength: 2 }}
                        />
                      </FormControl>
                      {formik.errors.IndigenousCommunitiesNumber ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.IndigenousCommunitiesNumber}
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>

                  <Grid container spacing={1}>
                    {/* Tabla Asistencia */}
                    <Grid item xs={12} sm={12} md={12}>
                      <label className="responsiveLabel">
                        <b>Descripción:</b> Indique el(los) nombre de la
                        comunidad indígena a la que pertenecen las personas que
                        participarán en la asistencia solicitada.
                      </label>
                      <br></br>
                      <br></br>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <Table272
                        IdTechnicalAssistanceAnswer={
                          assistanceForm.IdTechnicalAssistanceAnswer
                        }
                        IndigenousCommunitiesNumber={
                          formik.values.IndigenousCommunitiesNumber
                        }
                        formik={formik.setFieldValue}
                      />
                      {formik.errors.validateTable272 ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.validateTable272}
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Grid container spacing={1} className="button__container">
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            style={{ textAlign: 'left' }}
            className="continerButtonNav"
          >
            <Button
              onClick={() => previous()}
              variant="contained"
              className="button__wizard button__previous"
            >
              Anterior
            </Button>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            style={{ textAlign: 'right' }}
            className="continerButtonNav"
          >
            <Grid container>
              <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>
                <LoadingButton
                  loadingPosition="start"
                  variant="contained"
                  loading={saving}
                  className="button__wizard button__next"
                  onClick={() => validateFormStatus()}
                >
                  {assistanceForm.IdBeneficiaryType === 2
                    ? 'Siguiente'
                    : 'Registrar'}
                </LoadingButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Grid>
  )
}
